const updateTypes = {
  checked: [
    "radio",
    "checkbox"
  ],
  selected: [
    "option",
  ],
  value: [
    "select-one",
    "select-multiple",
    "button",
    "color",
    "date",
    "datetime",
    "datetime-local",
    "email",
    "hidden",
    "month",
    "number",
    "password",
    "range",
    "reset",
    "search",
    "submit",
    "tel",
    "text",
    "textarea",
    "time",
    "url",
    "week"
  ]
};

export type InputOrSelect = HTMLInputElement | HTMLSelectElement;
const isSelect = (el: InputOrSelect): el is HTMLSelectElement => {
  return el instanceof HTMLSelectElement;
}

export class InputHelper {
  constructor(){};

  static getElementType(element: InputOrSelect): string {
    return (element.type || element.nodeName).toLowerCase();
  }

  static reset(element: InputOrSelect) {
    const resetProp = (input: InputOrSelect, prop: string, defaultVal: boolean|string) => {
      let didPropValueChange = false;

      if (typeof(element[prop]) != 'undefined') {
        didPropValueChange = element[prop] !== defaultVal;
        element[prop] = defaultVal;
      }

      return didPropValueChange;
    }

    let didInputPropsChange = false;

    if (isSelect(element) || element.type === 'text') {
      didInputPropsChange = resetProp(element, 'value', '');
    } else if (element.type === 'checkbox' || element.type === 'radio') {
      didInputPropsChange = resetProp(element, 'checked', false);
    } else {
      didInputPropsChange =
        resetProp(element, 'checked', false) ||
        resetProp(element, 'selected', false) ||
        resetProp(element, 'value', '');
    }

    if (didInputPropsChange) {
      this.triggerChange(element);
    }
  }

  static getPropertyToUpdate(element: InputOrSelect): string {
    const type = this.getElementType(element);

    for (let updateType in updateTypes) {
      if (updateTypes[updateType].includes(type)) {
        return updateType;
      }
    }

    return undefined;
  }

  static triggerChange(input: InputOrSelect) {
    const event = document.createEvent('Event');
    event.initEvent('change', true, true);
    input.dispatchEvent(event);
  }

  static copyValue(sourceInput: InputOrSelect, destInput: InputOrSelect) {
    const propertyToUpdate = this.getPropertyToUpdate(sourceInput);
    destInput[propertyToUpdate] = sourceInput[propertyToUpdate];
    this.triggerChange(destInput);
  }

  static valuesMatch(input1: InputOrSelect, input2: InputOrSelect): boolean {
    const propertyToUpdate = this.getPropertyToUpdate(input1);
    return input1[propertyToUpdate] == input2[propertyToUpdate];
  }

  static isEmpty(input: InputOrSelect): boolean {
    const property = this.getPropertyToUpdate(input);
    return input[property] ? false : true;
  }
}